import { defineAction, object } from '~/prix'
import updateCnaesAction from './updateCnaes.action.json'

const updateCnaesDefinition = defineAction({
  ...updateCnaesAction,
  input: object({}),
  output: object({}),
})

export default updateCnaesDefinition
